import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'rebass';
import CopyToClipboard from 'react-copy-to-clipboard';

class CopyToClipboardButton extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    value: PropTypes.string,
    width: PropTypes.number,
    tiny: PropTypes.bool,
  };

  static defaultProps = {
    name: null,
    value: '',
    width: 170,
    tiny: false,
  };

  state = {
    copied: false,
  };

  render() {
    const { name, value, width, tiny } = this.props;
    const style = {
      marginTop: '3px',
      fontSize: '9px',
      minHeight: '30px',
      lineHeight: '9px',
      width,
    };
    if (tiny) {
      style.minHeight = 20;
      style.padding = 5;
      style.lineHeight = 1;
    }
    return (
      <CopyToClipboard
        text={value}
        onCopy={() => {
          this.setState({ copied: true });
          setTimeout(() => this.setState({ copied: false }), 1000);
        }}
      >
        <Button
          p={1}
          style={style}
        >
          {this.state.copied ? 'Copied' : (name || 'Copy to Clipboard')}
        </Button>
      </CopyToClipboard>
    );
  }
}

export default CopyToClipboardButton;
